import { Button, ButtonsGroup, Typo } from "#/atoms";
import { FC, memo, useCallback } from "react";

import { DESKTOP_SPACING } from "@/theme";
import { Modal } from "#/molecules";
import { RemoveProps } from "./Remove.interface";

const Remove: FC<RemoveProps> = ({ description, onCancel, onClose, onRemove, title }) => {
  const handleCancel = useCallback(() => {
    onCancel();
    onClose();
  }, []);

  const handleRemove = useCallback(() => {
    onRemove();
    onClose();
  }, []);
  
  return (
    <Modal onClose={onClose} title={title}>
      <Typo>{description}</Typo>
      <ButtonsGroup fullWidth margin={`${DESKTOP_SPACING.EL}px 0 0`}>
        <Button actionType="outline" onClick={handleCancel}>Cancel</Button>
        <Button actionType="solid" buttonColor="secondary" onClick={handleRemove}>Remove</Button>
      </ButtonsGroup>
    </Modal>
  );
};

export default memo(Remove);